import { render, staticRenderFns } from "./protocol-en.vue?vue&type=template&id=75a24c9c&scoped=true"
import script from "./protocol-en.vue?vue&type=script&lang=js"
export * from "./protocol-en.vue?vue&type=script&lang=js"
import style0 from "./protocol-en.vue?vue&type=style&index=0&id=75a24c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a24c9c",
  null
  
)

export default component.exports